// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"4331476b","247":"27cd7f81","627":"9247a17f","867":"28c9d2b5","923":"e7452041","938":"345c4c63"}[chunkId] + ".chunk.js";
};